import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_DATES,
  SET_LOADING,
  SET_UPDATES_LOADING,
  FETCH_CHART_SUCCESS,
  UPDATE_DATES,
  UPDATE_CUSTOM_RANGE,
  SET_FILTERS_DIRTY,
  UPDATE_DRAFT_TYPE,
  UPDATE_DRAFT_ATTEMPT,
  RESET_FILTER
} from "./draftSagas";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOption,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";

export const initialState = {
  isLoading: true,
  initialRequest: false,
  updatesLoading: false,
  currentUser: {},
  chartsData: {
    dataPoints: [],
    summaryBreakdown: [],
    pieChart: {},
    table: {}
  },
  filtersDirty: false,
  filterOptions: {
    draftTypeOptions: [],
    draftAttemptOptions: []
  },
  selectedFilters: {
    draftTypes: [],
    draftAttempts: []
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      rangeOptions: getRangeOptions(
        state.currentUser.calendarEndDate,
        state.currentUser.calendarStartDate
      ),
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        rangeOption: getSelectedRangeOption(action.payload.endDate)
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filterOptions: {
        draftTypeOptions: action.payload.draftTypeOptions,
        draftAttemptOptions: action.payload.draftAttemptOptions
      },
      selectedFilters: {
        ...state.selectedFilters,
        draftTypes: action.payload.draftTypeOptions,
        draftAttempts: action.payload.draftAttemptOptions
      }
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartsData: action.payload
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      filtersDirty: true,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        rangeOption: getSelectedRangeOptionWithCustom(action)
      }
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        ...getDateRanges(
          state.currentUser.calendarEndDate,
          action.payload,
          state.currentUser.calendarStartDate
        ),
        rangeOption: action.payload
      }
    }),
    [UPDATE_DRAFT_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        draftTypes: action.payload
      }
    }),
    [UPDATE_DRAFT_ATTEMPT]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        draftAttempts: action.payload
      }
    }),
    [RESET_FILTER]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: {
        ...state.selectedFilters,
        draftTypes: state.filterOptions.draftTypeOptions,
        draftAttempts: state.filterOptions.draftAttemptOptions
      }
    })
  },
  initialState
);
